import { createContext } from "react";
import { LoggedOnAppUser } from "./LoggedOnAppUser";
import { AppUserModel } from "common247";

export type AuthContextType = {
  signUp: (email: string, password: string) => Promise<AppUserModel | null>;
  signIn: (email: string, password: string) => Promise<AppUserModel | null>;
  signInWithGoogle: () => Promise<AppUserModel | null>;
  signInWithMicrosoft: () => Promise<AppUserModel | null>;
  signOut: () => void;
  emailVerification: () => void;
  sendPasswordReset: () => Promise<void>;
  refreshUser: () => Promise<void>;
  user: LoggedOnAppUser | undefined;

  isAuthenticated: boolean;
  isInitialized: boolean;
};

export const AuthContext = createContext<AuthContextType>({
  signUp: async (email: string, password: string) => null,
  signIn: async (email: string, password: string) => null,
  signInWithGoogle: async () => null,
  signInWithMicrosoft: async () => null,
  signOut: () => null,
  emailVerification: () => null,
  sendPasswordReset: async () => { },
  refreshUser: async () => { },
  user: undefined,
  isAuthenticated: false,
  isInitialized: false,
});
